import { Capacitor } from '@capacitor/core';
import { bootstrapApplication } from '@angular/platform-browser';

// Ensure the native bridge (incl. CapacitorHttp fetch/XHR patches) is live
// before Angular issues its first API call.
void Capacitor.isNativePlatform();
import { App } from './app/app';
import { appConfig } from './app/app.config';

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
